module.exports = __webpack_public_path__ + "media/images/logo/fwx-80e53d7aee54659121a0c7196a9bc9ef.png";